import React, { useState, useEffect, useContext, useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";
import {
    Container,
    Card,
    CardBody,
    Table,
    Button,
    Badge,
    Spinner,
    Input,
    FormGroup,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Label,
    Alert,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    InputGroup,
    InputGroupAddon,
    InputGroupText
} from "reactstrap";
import Select from "react-select";
import featuresService from '../../services/api/features-service';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faCheck,
    faTimes,
    faSearch,
    faPhone,
    faEnvelope,
    faMapMarkerAlt,
    faCity,
    faFileExcel,
    faRedo,
    faSort,
    faSortUp,
    faSortDown
} from "@fortawesome/free-solid-svg-icons";
import classnames from "classnames";

import adminGrievanceService from "../../services/api/grievance-service";
import ProjectContext from "../../ProjectContext";
import UserContext from "../../UserContext";

// --- Constants ---
const REJECTION_REASONS = [
    { label: "અપમાનજનક, ધમકીભરી અથવા અશ્લીલ ભાષા ધરાવે છે.", value: "abusive_or_offensive_language" },
    { label: "હિંસક, ખલેલ પહોંચાડતી ગ્રાફિક અથવા અયોગ્ય છબીઓ/વીડિયોનો સમાવેશ થાય છે.", value: "graphic_or_inappropriate_media" },
    { label: "મુદ્દાથી સંબંધિત ન હોય તેવા ફોટા/વીડિયો અપલોડ કર્યા છે.", value: "irrelevant_media" },
    { label: "ફરિયાદ કોઈ જાહેર મુદ્દા કે સમુદાયની સમસ્યા સાથે સંબંધિત નથી.", value: "not_public_issue" },
    { label: "માહિતી અસ્પષ્ટ, અપૂર્ણ અથવા મહત્ત્વપૂર્ણ વિગતો ખૂટે છે.", value: "unclear_or_incomplete" },
    { label: "ખોટા દાવા, ગેરમાર્ગે દોરનારી અથવા એવી માહિતી જેની ચકાસણી કરી શકાતી નથી. (પુરાવા કે સ્પષ્ટતા વગરની માહિતી)", value: "unverified_or_false_information" },
    { label: "આ વ્યક્તિગત/પારિવારિક વિવાદ છે, જાહેર બાબત સાથે લેવાદેવા નથી.", value: "personal_or_family_dispute" },
    { label: "આ ફરિયાદ ગુજરાત બહારના મુદ્દા વિશે છે.", value: "outside_coverage_area" },
    { label: "આ ફરિયાદ/રજૂઆત અગાઉ થઈ ચૂકી છે.", value: "duplicate" },
    { label: "સ્પામ માહિતી, પ્રમોશનલ માહિતી અથવા જાહેરાતોનો સમાવેશ થાય છે.", value: "spam_or_promotional" },
    { label: "ખોટી શ્રેણી અથવા સંબંધિત વિષયમાં સબમિટ કરેલ છે.", value: "wrong_category_or_topic" },
    { label: "કોપીરાઈટ કરેલી અથવા ચોરાયેલ ફોટો/મહિતી ધરાવે છે.", value: "copyright_or_stolen_content" },
    { label: "સંમતિ વિના કોઈપણ વ્યક્તિની ગોપનીયતાનું ઉલ્લંઘન કરે છે.", value: "privacy_violation" },
    { label: "આ સમસ્યા પહેલાથી જ ઉકેલાઈ ગઈ છે.", value: "already_resolved" },
    { label: "રાજકીય પ્રચાર/પ્રોપેગેન્ડા દર્શાવતી માહિતી", value: "political_propaganda" },
    { label: "અન્ય (Other)", value: "Other" },
];

const REJECTION_REASON_FILTER_OPTIONS = [
    // { label: "All rejection reasons", value: "" },
    ...REJECTION_REASONS
];

const GUJARAT_CITY_MAP = {
    "Ahmedabad": "અમદાવાદ",
    "Amreli": "અમરેલી",
    "Anand": "આણંદ",
    "Aravalli": "અરવલ્લી",
    "Banaskantha": "બનાસકાંઠા",
    "Bharuch": "ભરૂચ",
    "Bhavnagar": "ભાવનગર",
    "Botad": "બોટાદ",
    "Chhota Udaipur": "છોટા ઉદેપુર",
    "Dahod": "દાહોદ",
    "Dang": "ડાંગ",
    "Devbhoomi Dwarka": "દેવભૂમિ દ્વારકા",
    "Gandhinagar": "ગાંધીનગર",
    "Gir Somnath": "ગીર સોમનાથ",
    "Jamnagar": "જામનગર",
    "Junagadh": "જુનાગઢ",
    "Kutch": "કચ્છ",
    "Kheda": "ખેડા",
    "Mahisagar": "મહીસાગર",
    "Mehsana": "મહેસાણા",
    "Morbi": "મોરબી",
    "Narmada": "નર્મદા",
    "Navsari": "નવસારી",
    "Panchmahal": "પંચમહાલ",
    "Patan": "પાટણ",
    "Porbandar": "પોરબંદર",
    "Rajkot": "રાજકોટ",
    "Sabarkantha": "સાબરકાંઠા",
    "Surat": "સુરત",
    "Surendranagar": "સુરેન્દ્રનગર",
    "Tapi": "તાપી",
    "Vadodara": "વડોદરા",
    "Valsad": "વલસાડ"
};

const CATEGORY_TRANSLATION_MAP = {
    "Roads and Infrastructure": "રસ્તાઓ અને ઇન્ફ્રાસ્ટ્રક્ચર",
    "Sanitation and Garbage": "સફાઈ અને ગંદગી સંબંધિત સમસ્યા",
    "Water and Drainage": "પાણી અને ગટર વ્યવસ્થા",
    "Power and Street Lighting": "પાવર અને સ્ટ્રીટ લાઇટિંગ",
    "Public Transport and Traffic": "જાહેર પરિવહન અને ટ્રાફિક સમસ્યા",
    "Encroachment and Illegal Construction": "અતિક્રમણ, ગેરકાયદેસર બાંધકામ, મકાન મુદ્દાઓ",
    "Health and Safety": "આરોગ્ય અને સલામતી",
    "Environment, Parks and Pollution": "પર્યાવરણ અને ઉદ્યાનો, પ્રદૂષણ",
    "Governance and Service Delivery": "શાસન-સેવા વિતરણ, સરકારી કચેરીઓની ફરિયાદ",
    "Law and Order": "કાયદો અને વ્યવસ્થા",
    "School and Education": "શાળા અને શિક્ષણ",
    "Other": "અન્ય"
};
const fuzzySearchOption = (candidate, input, map) => {
    if (!input) return true;
    const search = input.toLowerCase();
    const label = candidate.label ? String(candidate.label).toLowerCase() : "";

    // 1. Direct Match (User typed "Amreli" and option is "Amreli")
    if (label.includes(search)) return true;

    // 2. Map Match (User typed "Ahme" and option is "અમદાવાદ")
    // We look for the map entry where the Value is the Option Label, check the Key
    const foundEntry = Object.entries(map).find(([eng, guj]) => guj === candidate.label || eng === candidate.label);

    if (foundEntry) {
        const [eng, guj] = foundEntry;
        // Check if the input matches EITHER the English key OR the Gujarati value
        if (eng.toLowerCase().includes(search) || guj.includes(search)) {
            return true;
        }
    }

    return false;
};
const baseSelectStyles = {
    container: (provided) => ({
        ...provided,
        marginRight: "10px",
    }),
    clearIndicator: (provided) => ({
        ...provided,
        cursor: "pointer", // Forces the hand icon
        ":hover": {
            color: "#dc3545" // Optional: Turns red on hover
        }
    }),
    control: (provided, state) => ({
        ...provided,
        // Add Border and White Background to look like a Text Holder
        border: state.isFocused ? "1px solid #5e72e4" : "1px solid #dee2e6",
        backgroundColor: "#fff",
        boxShadow: state.isFocused ? "0 0 0 1px #5e72e4" : "none",
        borderRadius: "0.25rem", // Standard Bootstrap rounded corner
        cursor: "text", // Changes cursor to I-beam to indicate text input
        padding: "0 4px",
        height: "40px",
        minHeight: "40px",
        display: "flex",
        alignItems: "center",
        transition: "all 0.2s",
        "&:hover": {
            borderColor: "#5e72e4"
        }
    }),
    valueContainer: (provided) => ({
        ...provided,
        padding: "0 8px",
        margin: 0,
    }),
    input: (provided) => ({
        ...provided,
        margin: 0,
        padding: 0,
        color: "#495057"
    }),
    singleValue: (provided) => ({
        ...provided,
        margin: 0,
        color: "#1f2937", // Darker text for readability
        fontSize: "0.9rem",
        fontWeight: "400" // Normal weight (removed bold)
    }),
    placeholder: (provided) => ({
        ...provided,
        margin: 0,
        color: "#6c757d", // Muted placeholder text
        fontSize: "0.9rem",
        fontWeight: "400"
    }),
    indicatorSeparator: () => ({ display: "none" }),
    dropdownIndicator: (provided) => ({
        ...provided,
        color: "#6c757d",
        padding: "0 8px",
    }),
    menu: (provided) => ({
        ...provided,
        zIndex: 9999,
        marginTop: "4px",
        boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
        border: "1px solid #f3f4f6",
        borderRadius: "0.375rem"
    }),
    option: (provided, state) => ({
        ...provided,
        fontSize: "0.9rem",
        backgroundColor: state.isSelected
            ? "#5e72e4"
            : state.isFocused
                ? "#f6f9fc"
                : "#fff",
        color: state.isSelected ? "#fff" : "#1f2937",
        cursor: "pointer",
        padding: "10px 15px"
    })
};
// --- Custom Pagination Component (Clean & Modern Look) ---
const CustomPagination = ({ activePage, itemsCountPerPage, totalItemsCount, pageRangeDisplayed, onChange }) => {
    const pageNumbers = [];
    const totalPages = Math.ceil(totalItemsCount / itemsCountPerPage);
    const startPage = Math.max(1, activePage - Math.floor(pageRangeDisplayed / 2));
    const endPage = Math.min(totalPages, startPage + pageRangeDisplayed - 1);

    for (let i = startPage; i <= endPage; i++) {
        pageNumbers.push(i);
    }

    // -- Styles --
    const containerStyle = {
        display: 'flex',
        alignItems: 'center',
        gap: '5px',
        margin: 0,
        padding: 0,
        listStyle: 'none'
    };

    const btnBaseStyle = {
        border: 'none',
        background: 'transparent',
        color: '#8898aa',
        width: '30px',
        height: '30px',
        borderRadius: '50%',
        fontSize: '0.875rem',
        fontWeight: '600',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        outline: 'none',
        lineHeight: 1,
        padding: 0
    };

    const activeStyle = {
        ...btnBaseStyle,
        backgroundColor: '#5e72e4',
        color: '#ffffff',
        boxShadow: '0 4px 6px rgba(50,50,93,0.11), 0 1px 3px rgba(0,0,0,0.08)'
    };

    const disabledStyle = {
        ...btnBaseStyle,
        color: '#e9ecef',
        cursor: 'not-allowed'
    };

    return (
        <div style={containerStyle}>
            <button
                style={activePage === 1 ? disabledStyle : btnBaseStyle}
                onClick={() => activePage > 1 && onChange(activePage - 1)}
                disabled={activePage === 1}
                title="Previous Page"
            >
                <span aria-hidden="true" style={{ fontSize: '1.2rem', marginTop: '-2px' }}>&laquo;</span>
            </button>

            {pageNumbers.map(number => (
                <button
                    key={number}
                    style={activePage === number ? activeStyle : btnBaseStyle}
                    onClick={() => onChange(number)}
                    onMouseEnter={(e) => {
                        if (activePage !== number) {
                            e.currentTarget.style.backgroundColor = '#f6f9fc';
                            e.currentTarget.style.color = '#5e72e4';
                        }
                    }}
                    onMouseLeave={(e) => {
                        if (activePage !== number) {
                            e.currentTarget.style.backgroundColor = 'transparent';
                            e.currentTarget.style.color = '#8898aa';
                        }
                    }}
                >
                    {number}
                </button>
            ))}

            <button
                style={activePage === totalPages ? disabledStyle : btnBaseStyle}
                onClick={() => activePage < totalPages && onChange(activePage + 1)}
                disabled={activePage === totalPages}
                title="Next Page"
            >
                <span aria-hidden="true" style={{ fontSize: '1.2rem', marginTop: '-2px' }}>&raquo;</span>
            </button>
        </div>
    );
};

const GrievanceDashboard = () => {
    const project = useContext(ProjectContext);
    const rawUserCtx = useContext(UserContext);
    const history = useHistory();
    const location = useLocation();

    // --- Sorting State ---
    const [sortConfig, setSortConfig] = useState({ key: 'created_at', direction: 'desc' });

    const requestSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
        setPagination(prev => ({ ...prev, currentPage: 1 }));
    };

    const getSortIcon = (columnKey) => {
        if (sortConfig.key !== columnKey) return faSort;
        if (columnKey === 'created_at') {
            return sortConfig.direction === 'asc' ? faSortDown : faSortUp;
        }
        return sortConfig.direction === 'asc' ? faSortUp : faSortDown;
    };

    const projectId = project?.id;
    if (projectId === '') {
        history.push("/project/allprojects");
    }
    const currentUser = rawUserCtx?.userdetails || rawUserCtx;
    const rolesFromProject = project?.current_user_roles || [];
    const rolesFromUser = currentUser?.current_user_roles || currentUser?.roles || [];

    const userRoles = rolesFromProject.length ? rolesFromProject : rolesFromUser;
    const hasGrievanceAccess = userRoles && userRoles.length > 0;

    let accessLevel = "admin";
    if (userRoles.includes("admin") || userRoles.includes("owner")) {
        accessLevel = "admin";
    } else if (userRoles.includes("accounts")) {
        accessLevel = "accounts";
    } else if (userRoles.includes("editor")) {
        accessLevel = "editor";
    }

    const canManageCities = accessLevel === "admin";
    const canModerate = accessLevel === "admin" || accessLevel === "accounts";
    const canBulkAct = canModerate;
    const canRowAct = canModerate;

    const [activeTab, setActiveTab] = useState(() => {
    return sessionStorage.getItem("grievanceActiveTab") || "new";
});
    const [grievances, setGrievances] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isFeatureLoading, setIsFeatureLoading] = useState(false);
    const [isFeatureEnabled, setIsFeatureEnabled] = useState(true);

    const [locations, setLocations] = useState([]);
    const [categories, setCategories] = useState([]);
    const [cityFilter, setCityFilter] = useState(null);
    const [categoryFilter, setCategoryFilter] = useState(null);

    const [searchQuery, setSearchQuery] = useState("");
    const [rejectionReasonFilter, setRejectionReasonFilter] = useState("");

    const [pagination, setPagination] = useState({
        currentPage: 1,
        totalItems: 0,
        limit: 10
    });

    const [jumpToPage, setJumpToPage] = useState('');
    const [selectedIds, setSelectedIds] = useState(new Set());

    const [customMsgModalOpen, setCustomMsgModalOpen] = useState(false);
    const [targetGrievanceId, setTargetGrievanceId] = useState(null);
    const [customReason, setCustomReason] = useState("");
    const [bulkRejectModalOpen, setBulkRejectModalOpen] = useState(false);
    const [bulkRejectReason, setBulkRejectReason] = useState(null);
    const [bulkCustomNote, setBulkCustomNote] = useState("");
    const [confirmModalState, setConfirmModalState] = useState({
        show: false,
        ids: [],
        action: "",
        title: "",
        message: "",
        btnColor: "primary",
        btnText: "Confirm"
    });
    const [exportModalOpen, setExportModalOpen] = useState(false);
    const [exportFields, setExportFields] = useState(["title", "category", "created_at"]);
    const [exportError, setExportError] = useState("");

    const [alertState, setAlertState] = useState({
        show: false,
        color: "",
        message: ""
    });
    useEffect(() => {
        sessionStorage.setItem("grievanceActiveTab", activeTab);

        // Optional: Keep your existing URL update logic if you want
        history.replace(location.pathname, { activeTab: activeTab });
    }, [activeTab, history, location.pathname]);
    // --- Helpers Logic ---
    const handleSelectInputChange = (inputValue, actionMeta) => {
        if (actionMeta.action === "input-change") {
            if (inputValue.length <= 30) return inputValue;
            return inputValue.substring(0, 30);
        }
        return inputValue;
    };

    let expectedDefaultKey = 'created_at';
    if (activeTab === 'accepted' || activeTab === 'rejected') {
        expectedDefaultKey = 'updated_at';
    } else if (activeTab === 'resolved') {
        expectedDefaultKey = 'resolved_at';
    }
    const isSortModified = sortConfig.key !== expectedDefaultKey || sortConfig.direction !== 'desc';
    const showReset = cityFilter || categoryFilter || searchQuery || rejectionReasonFilter || selectedIds.size > 0 || isSortModified;
    // --- Effects ---
    useEffect(() => {
        history.replace(location.pathname, { activeTab: activeTab });
    }, [activeTab, history, location.pathname]);

    useEffect(() => {
        if (!projectId) return;

        const loadMetadata = async () => {
            setIsFeatureLoading(true);
            try {
                const featureStatus = await featuresService.getFeatureStatus('enable_grievance_management', projectId);
                if (featureStatus.status && featureStatus.data) {
                    setIsFeatureEnabled(featureStatus.data.enable_grievance_management);
                } else {
                    setIsFeatureEnabled(false);
                }
            } catch (err) {
                console.log("Failed to load grievance metadata", err);
                setIsFeatureEnabled(false);
            } finally {
                setIsFeatureLoading(false);
            }
        };
        loadMetadata();
    }, [projectId]);

    useEffect(() => {
        if (projectId && isFeatureEnabled) {
            fetchLocations();
            fetchCategories();
        }
    }, [projectId, isFeatureEnabled]);

    useEffect(() => {
        if (!projectId || !isFeatureEnabled) return;
        const delayDebounceFn = setTimeout(() => {
            fetchData();
        }, 600);
        return () => clearTimeout(delayDebounceFn);
    }, [
        projectId,
        isFeatureEnabled,
        activeTab,
        pagination.currentPage,
        cityFilter,
        categoryFilter,
        searchQuery,
        rejectionReasonFilter,
        sortConfig
    ]);

    useEffect(() => {
        setSelectedIds(new Set());
        setCityFilter(null);
        setCategoryFilter(null);
        setSearchQuery("");
        setRejectionReasonFilter("");
        setPagination((prev) => ({ ...prev, currentPage: 1 }));

        let defaultSortKey = 'created_at';
        if (activeTab === 'accepted' || activeTab === 'rejected') {
            defaultSortKey = 'updated_at';
        } else if (activeTab === 'resolved') {
            defaultSortKey = 'resolved_at';
        }

        setSortConfig({ key: defaultSortKey, direction: 'desc' });

    }, [activeTab]);

    // --- Export Logic ---
    const baseExportFields = [
        { label: "Title", key: "title" },
        { label: "Category", key: "category" },
        { label: "Description", key: "description" },
        { label: "City", key: "city" },
        { label: "State", key: "state" },
        { label: "Address", key: "address" },
        { label: "Mobile", key: "mobile_number" },
        { label: "Email", key: "email" },
        { label: "Created At", key: "created_at" }
    ];

    const getAvailableExportFields = () => {
        let fields = [...baseExportFields];
        if (activeTab === "rejected") {
            fields.push({ label: "Rejection Reason", key: "rejection_reason" });
        }
        else if (activeTab === "resolved") {
            fields.push({ label: "Resolved On", key: "resolved_at" });
        }
        return fields;
    };

    const availableExportFields = getAvailableExportFields();

    // ** CHANGED: Updated color logic to exclude 'primary' **
    const getCategoryColor = (cat) => {
        // Excluded 'primary'. Replaced 'default' with 'secondary' or 'dark' for valid Bootstrap colors
        const colors = ["info", "danger", "success", "dark", "secondary"];
        if (!cat) return "secondary";
        const hash = cat.split("").reduce((acc, char) => char.charCodeAt(0) + acc, 0);
        return colors[hash % colors.length];
    };

    const showAlert = (color, message) => {
        setAlertState({ show: true, color, message });
        setTimeout(() => setAlertState({ show: false, color: "", message: "" }), 3500);
    };

    const resetFilters = () => {
        setCityFilter(null);
        setCategoryFilter(null);
        setSearchQuery("");
        setRejectionReasonFilter("");
        setPagination((prev) => ({ ...prev, currentPage: 1 }));
        setSelectedIds(new Set());
        setSortConfig({ key: 'created_at', direction: 'desc' });
    };

    const paginationData = useMemo(() => {
        const firstRecord = (pagination.currentPage - 1) * pagination.limit + 1;
        const lastRecord = Math.min(pagination.currentPage * pagination.limit, pagination.totalItems || 0);
        const totalPages = Math.ceil(pagination.totalItems / pagination.limit);
        return { firstRecord, lastRecord, totalPages };
    }, [pagination.currentPage, pagination.totalItems, pagination.limit]);

    const handlePageJump = (e) => {
        if (e.key === 'Enter') {
            const page = parseInt(jumpToPage, 10);
            const totalPages = paginationData.totalPages;

            if (page >= 1 && page <= totalPages) {
                setPagination(prev => ({ ...prev, currentPage: page }));
                setJumpToPage('');
            } else {
                const msg = totalPages === 1
                    ? "There is only 1 page available."
                    : `Please enter a page number between 1 and ${totalPages}.`;

                showAlert("warning", msg);
                setJumpToPage('');
            }
        }
    };

    const openConfirmation = (ids, action) => {
        let config = {};
        if (action === "accept") {
            config = {
                title: "Confirm Approval",
                message: ids.length > 1
                    ? `Are you sure you want to approve ${ids.length} grievances?`
                    : "Are you sure you want to approve and publish this grievance?",
                btnColor: "success",
                btnText: "Yes, Approve"
            };
        } else if (action === "resolve") {
            config = {
                title: "Confirm Resolution",
                message: ids.length > 1
                    ? `Are you sure you want to mark ${ids.length} grievances as resolved?`
                    : "Are you sure you want to mark this grievance as resolved?",
                btnColor: "info",
                btnText: "Yes, Mark Resolved"
            };
        }
        setConfirmModalState({
            show: true,
            ids,
            action,
            ...config
        });
    };

    const executeConfirmation = () => {
        submitDecision(confirmModalState.ids, confirmModalState.action);
        setConfirmModalState({ ...confirmModalState, show: false });
    };

    const closeConfirmModal = () => {
        setConfirmModalState({ ...confirmModalState, show: false });
    };

    const openBulkRejectModal = () => {
        setBulkRejectModalOpen(true);
        setBulkRejectReason(null);
        setBulkCustomNote("");
    };

    const executeBulkReject = () => {
        if (!bulkRejectReason) return;

        let finalReason = bulkRejectReason.value;
        if (bulkRejectReason.value === "Other") {
            if (!bulkCustomNote.trim()) return;
            finalReason = bulkCustomNote.trim();
        }

        submitDecision(Array.from(selectedIds), "reject", finalReason);
        setBulkRejectModalOpen(false);
        setBulkRejectReason(null);
        setBulkCustomNote("");
    };

    const toggleExportModal = () => {
        setExportModalOpen(!exportModalOpen);
        setExportError("");
    };

    const handleFieldSelection = (fieldKey) => {
        setExportFields((prevFields) =>
            prevFields.includes(fieldKey)
                ? prevFields.filter((key) => key !== fieldKey)
                : [...prevFields, fieldKey]
        );
    };

    const handleSelectAll = () => {
        setExportFields((prevFields) =>
            prevFields.length === availableExportFields.length
                ? []
                : availableExportFields.map((field) => field.key)
        );
    };

    const performExportExcel = () => {
        let rowsToExport = [];
        if (selectedIds.size > 0) {
            rowsToExport = grievances.filter((g) => selectedIds.has(g._id));
        } else {
            rowsToExport = grievances;
        }

        if (!rowsToExport || rowsToExport.length === 0) {
            setExportError("No records available to export.");
            return;
        }

        if (exportFields.length === 0) {
            setExportError("Please select at least one field to export.");
            return;
        }

        const escapeCsv = (value) => {
            if (value === null || value === undefined) return "";
            const str = String(value);
            return `"${str.replace(/"/g, '""')}"`;
        };

        const headers = availableExportFields
            .filter((field) => exportFields.includes(field.key))
            .map((field) => field.label);

        const csvRows = [];
        csvRows.push(headers.map(escapeCsv).join(","));

        rowsToExport.forEach((item) => {
            const rowData = availableExportFields
                .filter((field) => exportFields.includes(field.key))
                .map((field) => {
                    const key = field.key;
                    let val = item[key];
                    if (key === "created_at" || key === "createdAt") {
                        val = item.created_at || item.createdAt;
                        val = val ? new Date(val).toLocaleString() : "";
                    } else if (key === "resolved_at") {
                        val = val ? new Date(val).toLocaleString() : "-";
                    }
                    return escapeCsv(val);
                });
            csvRows.push(rowData.join(","));
        });

        const csvContent = csvRows.join("\r\n");
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        const fileName = `grievances_${activeTab}_${new Date().toISOString().slice(0, 10)}.csv`;

        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        toggleExportModal();
    };

    // --- API Calls ---
    const fetchData = async () => {
        setIsLoading(true);
        try {
            let statusFilter = null;
            if (activeTab === "new") statusFilter = "pending";
            else if (activeTab === "accepted") statusFilter = "accepted";
            else if (activeTab === "rejected") statusFilter = "rejected";
            else if (activeTab === "resolved") statusFilter = "resolved";

            const filters = {
                tab: activeTab,
                status: statusFilter,
                city: cityFilter ? cityFilter.value : "All",
                category: categoryFilter ? categoryFilter.value : null,
                search: searchQuery,
                rejectionReason:
                    activeTab === "rejected" && rejectionReasonFilter
                        ? rejectionReasonFilter
                        : null,
                sortBy: sortConfig.key,
                sortOrder: sortConfig.direction

            };

            const res = await adminGrievanceService.fetchGrievanceList(
                projectId,
                filters,
                pagination.currentPage,
                pagination.limit
            );
            if (res?.status) {
                setGrievances(res.data.data || []);
                setPagination((prev) => ({
                    ...prev,
                    totalItems: res.data.pagination.total
                }));
            }
        } catch (err) {
            console.log(err);
            showAlert("danger", "Failed to load grievances.");
        } finally {
            setIsLoading(false);
        }
    };

    const fetchLocations = async () => {
        try {
            const res = await adminGrievanceService.getProjectLocations(projectId);
            if (res?.status) {
                setLocations(res.data || []);
            }
        } catch (err) {
            console.log("Failed to fetch locations", err);
        }
    };

    const fetchCategories = async () => {
        try {
            const res = await adminGrievanceService.getGrievanceCategories(projectId);
            if (res && res.status && Array.isArray(res.data)) {
                const catOptions = res.data.map((cat) => ({
                    label: cat.issue_name, // Display Name
                    // CHANGE: Use 'issue_name' so it matches what is saved in the DB
                    value: cat.issue_name
                }));
                setCategories(catOptions);
            }
        } catch (err) {
            console.log("Failed to fetch categories", err);
        }
    };
    const submitDecision = async (ids, action, reason = null) => {
        if (!canModerate) {
            showAlert("warning", "You do not have permission to perform this action.");
            return;
        }
        try {
            const res = await adminGrievanceService.takeDecision(projectId, ids, action, reason);
            if (res?.status) {
                showAlert("success", res.data.message || "Action completed successfully.");
                setCustomMsgModalOpen(false);
                setCustomReason("");
                fetchData();
            }
        } catch (err) {
            console.log(err);
            showAlert("danger", "Action failed.");
        }
    };

    const handleSingleReject = (id, reasonValue) => {
        if (reasonValue === "Other") {
            setTargetGrievanceId(id);
            setCustomMsgModalOpen(true);
        } else {
            submitDecision([id], "reject", reasonValue);
        }
    };

    const handleMarkResolved = (id) => {
        openConfirmation([id], "resolve");
    };

    // --- Renderers ---
    const renderTabButton = (id, label, colorClass) => {
        const isActive = activeTab === id;
        return (
            <button
                type="button"
                className={classnames(
                    "btn rounded-pill px-4 py-2 mr-2 mb-2 text-sm",
                    {
                        [`btn-${colorClass} shadow-sm text-white`]: isActive,
                        "btn-outline-secondary bg-white text-secondary border-secondary": !isActive
                    }
                )}
                onClick={() => setActiveTab(id)}
                style={{ fontSize: "0.9rem", transition: "all 0.15s ease-in-out" }}
            >
                {label}
            </button>
        );
    };

    const renderTable = () => {
        if (isLoading) {
            return (
                <div className="text-center py-5">
                    <Spinner color="primary" />
                    <div className="text-muted small mt-2">Loading grievances…</div>
                </div>
            );
        }

        if (grievances.length === 0) {
            return (
                <div className="py-5 text-center text-muted">
                    <div className="mb-2 font-weight-600">No grievances found.</div>
                    <div className="small">Try changing filters or search keywords.</div>
                </div>
            );
        }

        return (
            /* FIX: 
               1. Removed 'table-responsive' class to prevent ghost scrolling.
               2. Removed 'minHeight: 350px' to prevent blank space at the bottom 
                  when there are few rows.
            */
            <div style={{ overflowX: "visible" }}>
                <Table className="align-items-center table-hover align-middle mb-0">
                    <thead className="thead-light" style={{ verticalAlign: "middle" }}>
                        <tr style={{ height: "52px" }}>
                            {/* Checkbox Column */}
                            {hasGrievanceAccess && (
                                <th className="align-middle text-center" style={{ width: "40px" }}>
                                    <Input
                                        type="checkbox"
                                        style={{ margin: 0 }}
                                        onChange={(e) => {
                                            if (e.target.checked) setSelectedIds(new Set(grievances.map((g) => g._id)));
                                            else setSelectedIds(new Set());
                                        }}
                                        checked={grievances.length > 0 && selectedIds.size === grievances.length}
                                    />
                                </th>
                            )}

                            {/* --- COLUMN 1: ISSUE DETAILS (Alphabetical Sort) --- */}
                            <th
                                className="align-middle"
                                style={{ fontSize: "1rem", fontWeight: 700, cursor: "pointer", userSelect: "none" }}
                                onClick={() => requestSort('title')} // Sort by Title
                            >
                                <div className="d-flex align-items-center justify-content-between" style={{ maxWidth: '130px' }}>
                                    ISSUE DETAILS
                                    {/* The Icon */}
                                    <FontAwesomeIcon
                                        icon={getSortIcon('title')}
                                        className={sortConfig.key === 'title' ? "text-primary" : "text-muted"}
                                        style={{ opacity: sortConfig.key === 'title' ? 1 : 0.4 }}
                                    />
                                </div>
                            </th>

                            <th className="align-middle" style={{ fontSize: "1rem", fontWeight: 700 }}>
                                CATEGORIES
                            </th>

                            {/* --- COLUMN 3: REPORTER INFO (Time Sort) --- */}
                            <th className="align-middle" style={{ fontSize: "1rem", fontWeight: 700 }}>
                                REPORTER INFO
                            </th>

                            {/* --- LOCATION COLUMN (Sortable by City) --- */}
                            <th
                                className="align-middle"
                                style={{ fontSize: "1rem", fontWeight: 700, cursor: "pointer", userSelect: "none" }}
                                onClick={() => requestSort('city')} // Sort by 'city' field
                            >
                                <div className="d-flex align-items-center justify-content-between" style={{ maxWidth: '100px' }}>
                                    LOCATION
                                    <FontAwesomeIcon
                                        icon={getSortIcon('city')}
                                        className={sortConfig.key === 'city' ? "text-primary" : "text-muted"}
                                        style={{ opacity: sortConfig.key === 'city' ? 1 : 0.4 }}
                                    />
                                </div>
                            </th>

                            {/* Dynamic Columns based on Tabs */}
                            {(activeTab === "new" || activeTab === "accepted") && canRowAct && (
                                <th className="align-middle text-right" style={{ fontSize: "1rem", fontWeight: 700 }}>ACTIONS</th>
                            )}
                            {activeTab === "rejected" && (
                                <th className="align-middle" style={{ fontSize: "1rem", fontWeight: 700 }}>REJECTION REASON</th>
                            )}
                            {activeTab === "resolved" && (
                                <th className="align-middle" style={{ fontSize: "1rem", fontWeight: 700 }}>RESOLVED ON</th>
                            )}
                        </tr>
                    </thead>
                    <tbody style={{ overflow: "visible" }}>
                        {grievances.map((item) => {
                            const created = new Date(item.created_at || item.createdAt);
                            const rowId = item._id;

                            const badgeColor = getCategoryColor(item.category || "");

                            return (
                                <tr
                                    key={rowId}
                                    className={classnames({
                                        "bg-light": selectedIds.has(rowId)
                                    })}
                                    style={{ cursor: "pointer" }}
                                    onClick={() => history.push({
                                        pathname: `/dashboard/grievance/${rowId}`,
                                        state: { returnTab: activeTab } // Passing the current tab forward
                                    })}
                                >
                                    {hasGrievanceAccess && (
                                        <td
                                            className="align-middle text-center"
                                            style={{ width: "40px" }}
                                            onClick={(e) => e.stopPropagation()}
                                        >
                                            <Input
                                                type="checkbox"
                                                id={`chk-${rowId}`}
                                                style={{ margin: 0 }}
                                                checked={selectedIds.has(rowId)}
                                                onChange={() => {
                                                    const newSet = new Set(selectedIds);
                                                    if (newSet.has(rowId)) newSet.delete(rowId);
                                                    else newSet.add(rowId);
                                                    setSelectedIds(newSet);
                                                }}
                                            />
                                        </td>
                                    )}

                                    <td className="align-middle">
                                        <div style={{ maxWidth: "250px" }}>

                                            {/* Title Section */}
                                            <div
                                                className="text-dark mb-1 text-truncate"
                                                style={{
                                                    fontSize: "1rem",
                                                    fontWeight: 600,

                                                }}
                                                title={item.title || "Untitled issue"}
                                            >
                                                {item.title || "Untitled issue"}
                                            </div>

                                            {/* Description Section */}
                                            <div
                                                className="text-muted text-truncate"
                                                style={{ fontSize: "0.9rem" }}
                                                title={item.description || "No description provided."}
                                            >
                                                {item.description || "No description provided."}
                                            </div>

                                            {/* Date Section */}
                                            <small className="text-muted d-block mt-1">
                                                {created.toLocaleDateString()} at{" "}
                                                {created.toLocaleTimeString([], {
                                                    hour: "2-digit",
                                                    minute: "2-digit"
                                                })}
                                            </small>
                                        </div>
                                    </td>
                                    <td className="align-middle">
                                        <Badge
                                            className={classnames(
                                                "px-3 py-2 text-uppercase rounded-pill",
                                                `border border-${badgeColor} text-${badgeColor}`
                                            )}
                                            style={{
                                                fontSize: "0.75rem",
                                                backgroundColor: "transparent"
                                            }}
                                        >
                                            {item.category || "Uncategorised"}
                                        </Badge>
                                    </td>

                                    <td className="align-middle">
                                        <div className="d-flex flex-column">

                                            {/* 1. Phone Number Row */}
                                            {item.mobile_number && (
                                                <div
                                                    className="d-flex align-items-center mb-1"
                                                    style={{
                                                        fontSize: "0.9rem",
                                                        color: "#32325d",
                                                        fontWeight: 600
                                                    }}
                                                >
                                                    <FontAwesomeIcon
                                                        icon={faPhone}
                                                        className="text-muted"
                                                        style={{
                                                            width: 14,
                                                            marginRight: 8
                                                        }}
                                                    />
                                                    {item.mobile_number}
                                                </div>
                                            )}

                                            {/* 2. Email Row */}
                                            {item.email && (
                                                <div
                                                    className="d-flex align-items-center"
                                                    style={{
                                                        fontSize: "0.9rem",
                                                        color: "#525f7f",
                                                        fontWeight: 600
                                                    }}
                                                    title={item.email}
                                                >
                                                    <FontAwesomeIcon
                                                        icon={faEnvelope}
                                                        className="text-muted"
                                                        style={{
                                                            width: 14,
                                                            marginRight: 8
                                                        }}
                                                    />
                                                    <span className="text-truncate" style={{ maxWidth: "200px" }}>
                                                        {item.email}
                                                    </span>
                                                </div>
                                            )}

                                            {/* 3. Fallback */}
                                            {!item.mobile_number && !item.email && (
                                                <span className="text-muted small">
                                                    No contact info
                                                </span>
                                            )}
                                        </div>
                                    </td>

                                    <td
                                        className="align-middle"
                                        style={{ fontSize: "0.95rem" }}
                                    >
                                        <span className="text-dark d-flex align-items-center" title={`${item.city || "Unknown"}`}>
                                            <FontAwesomeIcon
                                                icon={faMapMarkerAlt}
                                                className="text-muted"
                                                style={{
                                                    width: 14,
                                                    marginRight: 10
                                                }}
                                            />
                                            {item.city || "Unknown"}
                                        </span>
                                    </td>

                                    {(activeTab === "new" || activeTab === "accepted") && canRowAct && (
                                        <td
                                            className="align-middle text-right"
                                            style={{ paddingRight: "1rem" }}
                                            onClick={(e) => e.stopPropagation()}
                                        >
                                            {activeTab === "new" && (
                                                <>
                                                    <Button
                                                        color="link"
                                                        size="lg"
                                                        className="px-2 mr-2"
                                                        title="Accept grievance"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            e.currentTarget.blur();
                                                            openConfirmation([rowId], "accept");
                                                        }}
                                                        style={{ boxShadow: "none", outline: "none" }}
                                                    >
                                                        <FontAwesomeIcon
                                                            icon={faCheck}
                                                            className="text-success"
                                                            style={{ fontSize: "1.3rem" }}
                                                        />
                                                    </Button>

                                                    <UncontrolledDropdown
                                                        direction="left"
                                                        className="d-inline-block"
                                                    >
                                                        <DropdownToggle
                                                            color="link"
                                                            size="lg"
                                                            className="px-2"
                                                            title="Reject grievance"
                                                            onClick={(e) => e.currentTarget.blur()}
                                                            style={{ boxShadow: "none", outline: "none" }}
                                                        >
                                                            <FontAwesomeIcon
                                                                icon={faTimes}
                                                                className="text-danger"
                                                                style={{ fontSize: "1.3rem" }}
                                                            />
                                                        </DropdownToggle>
                                                        <DropdownMenu
                                                            right
                                                            container="body"
                                                            style={{
                                                                zIndex: 9999,
                                                                maxHeight: "350px",
                                                                overflowY: "auto",
                                                                minWidth: "350px"
                                                            }}
                                                        >
                                                            <DropdownItem header>
                                                                Reason for rejection
                                                            </DropdownItem>
                                                            {REJECTION_REASONS.map((r) => (
                                                                <DropdownItem
                                                                    key={r.value}
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        handleSingleReject(
                                                                            rowId,
                                                                            r.value
                                                                        );
                                                                    }}
                                                                    style={{
                                                                        whiteSpace: "normal",
                                                                        padding: "10px 15px"
                                                                    }}
                                                                >
                                                                    {r.label}
                                                                </DropdownItem>
                                                            ))}
                                                        </DropdownMenu>
                                                    </UncontrolledDropdown>
                                                </>
                                            )}

                                            {activeTab === "accepted" && (
                                                <>
                                                    <UncontrolledDropdown
                                                        direction="left"
                                                        className="d-inline-block mr-2"
                                                    >
                                                        <DropdownToggle
                                                            color="link"
                                                            size="lg"
                                                            className="px-2"
                                                            title="Reject grievance"
                                                            onClick={(e) => e.currentTarget.blur()}
                                                            style={{ boxShadow: "none", outline: "none" }}
                                                        >
                                                            <FontAwesomeIcon
                                                                icon={faTimes}
                                                                className="text-danger"
                                                                style={{ fontSize: "1.3rem" }}
                                                            />
                                                        </DropdownToggle>
                                                        <DropdownMenu
                                                            right
                                                            container="body"
                                                            style={{
                                                                zIndex: 9999,
                                                                maxHeight: "350px",
                                                                overflowY: "auto",
                                                                minWidth: "350px"
                                                            }}
                                                        >
                                                            <DropdownItem header>
                                                                Reason for rejection
                                                            </DropdownItem>
                                                            {REJECTION_REASONS.map((r) => (
                                                                <DropdownItem
                                                                    key={r.value}
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        handleSingleReject(
                                                                            rowId,
                                                                            r.value
                                                                        );
                                                                    }}
                                                                    style={{
                                                                        whiteSpace: "normal",
                                                                        padding: "10px 15px"
                                                                    }}
                                                                >
                                                                    {r.label}
                                                                </DropdownItem>
                                                            ))}
                                                        </DropdownMenu>
                                                    </UncontrolledDropdown>
                                                    <Button
                                                        color="link"
                                                        size="lg"
                                                        className="px-2"
                                                        title="Mark as resolved"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            e.currentTarget.blur();
                                                            handleMarkResolved(rowId);
                                                        }}
                                                        style={{ boxShadow: "none", outline: "none" }}
                                                    >
                                                        <FontAwesomeIcon
                                                            icon={faCheck}
                                                            className="text-info"
                                                            style={{ fontSize: "1.3rem" }}
                                                        />
                                                    </Button>
                                                </>
                                            )}
                                        </td>
                                    )}

                                    {activeTab === "rejected" && (
                                        <td className="align-middle">
                                            <div
                                                className="text-muted"
                                                style={{
                                                    maxWidth: "220px",
                                                    display: "inline-block",
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    verticalAlign: "middle",
                                                    fontSize: "0.85rem"
                                                }}
                                                title={item.rejection_reason || "No reason specified"}
                                            >
                                                {item.rejection_reason || "No reason specified"}
                                            </div>
                                        </td>
                                    )}

                                    {activeTab === "resolved" && (
                                        <td className="align-middle" style={{ fontSize: "0.9rem" }}>
                                            {item.resolved_at
                                                ? new Date(item.resolved_at).toLocaleString()
                                                : "—"}
                                        </td>
                                    )}
                                </tr>
                            );
                        })}
                    </tbody>
                </Table>
            </div>
        );
    };

    if (!hasGrievanceAccess) {
        return (
            <div className="py-4">
                <Container fluid>
                    <Card className="shadow-sm border-0 mt-4">
                        <CardBody className="p-5 text-center">
                            <h3 className="mb-3 text-dark">Access Restricted</h3>
                            <p className="text-muted mb-4">
                                You don't have permission to view grievance data for this project.
                                If you think this is a mistake, please contact the project admin.
                            </p>
                            <Button color="primary" onClick={() => history.push("/dashboard")}>
                                Go to Dashboard
                            </Button>
                        </CardBody>
                    </Card>
                </Container>
            </div>
        );
    }

    if (isFeatureLoading) {
        return (
            <div className="py-4">
                <Container fluid>
                    <div className="text-center py-5">
                        <Spinner color="primary" />
                        <div className="text-muted small mt-2">
                            Loading grievance module…
                        </div>
                    </div>
                </Container>
            </div>
        );
    }

    if (!isFeatureEnabled) {
        return (
            <div className="py-4">
                <Container fluid>
                    <Card className="shadow-sm border-0">
                        <CardBody className="p-4 text-center">
                            <h4 className="mb-2 text-dark">Grievance module is disabled</h4>
                            <p className="text-muted mb-0">
                                This project does not have the grievance management feature enabled.
                            </p>
                        </CardBody>
                    </Card>
                </Container>
            </div>
        );
    }

    return (
        <div className="py-4">
            <Container fluid>
                <div className="d-flex align-items-center justify-content-between mb-3">
                    <div>
                        <h2 className="mb-1 text-dark">Grievance Management</h2>
                        <div className="text-muted small">
                            Review, filter and act on citizen grievances
                        </div>
                    </div>
                    {alertState.show && (
                        <Alert
                            color={alertState.color}
                            className="mb-0 py-2 px-3 shadow-sm"
                        >
                            {alertState.message}
                        </Alert>
                    )}
                </div>

                <Card className="shadow-sm border-0">
                    <CardBody className="p-4">
                        {/* Toolbar: Filters Left, Search Right */}
                        <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-4 pb-3 border-bottom">
                            {/* LEFT SIDE: Filters */}
                            <div className="d-flex align-items-center mb-3 mb-md-0">
                                {/* Categories: Fixed Width 220px */}
                                {/* Categories: Fixed Width to look like a text box */}
                                <Select
                                    options={categories}
                                    value={categoryFilter}
                                    onChange={setCategoryFilter}
                                    onInputChange={handleSelectInputChange}
                                    placeholder="Select Category..." // Added a clearer prompt
                                    filterOption={(candidate, input) => {
                                        return fuzzySearchOption(candidate, input, CATEGORY_TRANSLATION_MAP);
                                    }}
                                    styles={{
                                        ...baseSelectStyles,
                                        // Set a minWidth so it looks like a text holder box
                                        container: (p) => ({ ...p, width: "220px", marginRight: "10px" })
                                    }}
                                    isClearable={true}
                                />

                                {/* Cities: Fixed Width to look like a text box */}
                                <Select
                                    options={Array.from(
                                        new Set(
                                            (locations || []).flatMap((loc) => loc.cities || [])
                                        )
                                    ).map((city) => ({ label: city, value: city }))}
                                    value={cityFilter}
                                    onChange={setCityFilter}
                                    onInputChange={handleSelectInputChange}
                                    placeholder="Select City..." // Added a clearer prompt
                                    styles={{
                                        ...baseSelectStyles,
                                        // Set a minWidth so it looks like a text holder box
                                        container: (p) => ({ ...p, width: "200px", marginRight: "10px" })
                                    }}
                                    filterOption={(candidate, input) => {
                                        return fuzzySearchOption(candidate, input, GUJARAT_CITY_MAP);
                                    }}
                                    isClearable={true}
                                />
                                {/* Reset Filter Button - Only Visible if filters active OR rows selected */}
                                {showReset && (
                                    <Button
                                        color="link"
                                        className="text-danger p-0 ml-2 font-weight-600"
                                        style={{ fontSize: "0.9rem", textDecoration: 'none' }}
                                        onClick={resetFilters}
                                    >
                                        <FontAwesomeIcon icon={faRedo} className="mr-1" /> Reset
                                    </Button>
                                )}
                            </div>

                            {/* RIGHT SIDE: Rejection Reason Filter + Search */}
                            <div className="d-flex align-items-center">
                                {activeTab === "rejected" && (
                                    <Select
                                        options={REJECTION_REASON_FILTER_OPTIONS}
                                        value={REJECTION_REASON_FILTER_OPTIONS.find(
                                            (o) => o.value === rejectionReasonFilter
                                        )}
                                        onChange={(option) =>
                                            setRejectionReasonFilter(
                                                option ? option.value : ""
                                            )
                                        }
                                        onInputChange={handleSelectInputChange}
                                        placeholder="Rejection reason..."

                                        /* 1. Custom Search Logic */
                                        filterOption={(candidate, inputValue) => {
                                            if (!inputValue) return true;
                                            const search = inputValue.toLowerCase();

                                            const label = candidate.label ? candidate.label.toLowerCase() : "";
                                            const value = candidate.data.value ? candidate.data.value.toLowerCase() : "";
                                            const valueWithSpaces = value.replace(/_/g, ' ');

                                            return (
                                                label.includes(search) ||
                                                value.includes(search) ||
                                                valueWithSpaces.includes(search)
                                            );
                                        }}

                                        /* 2. Custom Display Logic */
                                        formatOptionLabel={(option) => (
                                            <div>
                                                <div style={{ fontWeight: 'normal' }}>{option.label}</div>
                                            </div>
                                        )}

                                        styles={{
                                            ...baseSelectStyles,
                                            container: (p) => ({
                                                ...p,
                                                width: "auto",
                                                minWidth: "180px",
                                                maxWidth: "350px",
                                                marginRight: "15px"
                                            }),
                                            menu: (p) => ({
                                                ...p,
                                                width: "350px",
                                                zIndex: 9999
                                            })
                                        }}
                                        isClearable={true}
                                    />
                                )}

                                <InputGroup
                                    className="input-group-merge shadow-none border rounded align-items-center"
                                    style={{ width: "250px", height: "40px", backgroundColor: "#fff" }}
                                >
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText
                                            className="bg-transparent border-0 pl-3 d-flex align-items-center"
                                            style={{ height: "100%" }}
                                        >
                                            <FontAwesomeIcon icon={faSearch} className="text-muted small" />
                                        </InputGroupText>
                                    </InputGroupAddon>

                                    <Input
                                        className="bg-transparent border-0 pl-2"
                                        placeholder="Search requests..."
                                        style={{ fontSize: "0.9rem", height: "100%", boxShadow: 'none' }}
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                    />

                                    {searchQuery && (
                                        <InputGroupAddon addonType="append">
                                            <InputGroupText
                                                className="bg-transparent border-0 pr-3 d-flex align-items-center"
                                                style={{ cursor: "pointer", height: "100%" }}
                                                onClick={() => setSearchQuery("")}
                                            >
                                                <FontAwesomeIcon icon={faTimes} className="text-muted small" />
                                            </InputGroupText>
                                        </InputGroupAddon>
                                    )}
                                </InputGroup>
                            </div>
                        </div>

                        {/* Tabs + Bulk + Export + Manage Cities */}
                        <div className="d-flex flex-wrap align-items-center justify-content-between mb-3">
                            <div className="d-flex flex-wrap">
                                {renderTabButton("new", "New Requests", "red")}
                                {renderTabButton("accepted", "Live / Accepted", "success")}
                                {renderTabButton("rejected", "Rejected", "danger")}
                                {renderTabButton("resolved", "Resolved", "info")}
                            </div>

                            <div className="d-flex align-items-center">
                                {selectedIds.size > 0 && (activeTab === "new" || activeTab === "accepted") && canBulkAct && (
                                    <div className="small text-muted mr-3 d-flex align-items-center">
                                        <span className="mr-2" style={{ marginRight: '8px' }}>{selectedIds.size} selected</span>
                                        {activeTab === "new" && (
                                            <Button
                                                size="sm"
                                                color="success"
                                                className="mr-2 px-3" style={{ marginRight: '8px' }}
                                                onClick={() =>
                                                    openConfirmation(
                                                        Array.from(selectedIds),
                                                        "accept"
                                                    )
                                                }
                                            >
                                                Accept all
                                            </Button>
                                        )}

                                        {activeTab === "accepted" && (
                                            <Button
                                                size="sm"
                                                color="primary"
                                                className="mr-2 px-3" style={{ marginRight: '8px' }}
                                                onClick={() =>
                                                    openConfirmation(
                                                        Array.from(selectedIds),
                                                        "resolve"
                                                    )
                                                }
                                            >
                                                Resolve all
                                            </Button>
                                        )}

                                        <Button
                                            size="sm"
                                            color="danger"
                                            className="px-3" style={{ marginRight: '8px' }}
                                            onClick={openBulkRejectModal}
                                        >
                                            Reject all
                                        </Button>
                                    </div>
                                )}

                                {canManageCities && (
                                    <Button
                                        size="sm"
                                        color="info"
                                        // ADDED 'rounded-pill' here
                                        className="mr-2 px-3 rounded-pill"
                                        style={{ marginRight: '8px' }}
                                        onClick={() => history.push("/dashboard/grievance-locations")}
                                    >
                                        <FontAwesomeIcon icon={faCity} className="mr-1" style={{ marginRight: 5 }} />
                                        Manage Cities
                                    </Button>
                                )}

                                {grievances.length > 0 && (
                                    <Button
                                        size="sm"
                                        color="success"
                                        // ADDED 'rounded-pill' here
                                        className="px-3 rounded-pill"
                                        onClick={toggleExportModal}
                                    >
                                        <FontAwesomeIcon
                                            icon={faFileExcel}
                                            className="mr-1"
                                            style={{ marginRight: 5 }}
                                        />
                                        Export Excel
                                    </Button>
                                )}
                            </div>
                        </div>

                        {/* --- COMPACT PAGINATION SECTION --- */}
                        <div className="d-flex justify-content-end align-items-center py-3 border-bottom mb-3">
                            {pagination.totalItems > 0 ? (
                                <div className="d-flex align-items-center">
                                    <div className="text-muted fw-bold small text-nowrap mr-1">
                                        {paginationData.firstRecord}-{paginationData.lastRecord} of {pagination.totalItems}
                                    </div>
                                    <CustomPagination
                                        activePage={pagination.currentPage}
                                        itemsCountPerPage={pagination.limit}
                                        totalItemsCount={pagination.totalItems}
                                        pageRangeDisplayed={3}
                                        onChange={(page) => setPagination(prev => ({ ...prev, currentPage: page }))}
                                    />
                                    <Input
                                        type="number"
                                        min="1"
                                        max={paginationData.totalPages}
                                        placeholder="Go to page"
                                        value={jumpToPage}
                                        onChange={(e) => setJumpToPage(e.target.value)}
                                        onKeyDown={handlePageJump}
                                        className="form-control form-control-sm ml-2"
                                        style={{ width: '120px' }}
                                    // Optional: Disable input if only 1 page to avoid confusion, 
                                    // but leaving enabled allows user to see "There is only 1 page" error which they might expect based on logic.
                                    />
                                </div>
                            ) : (
                                <div className="text-muted small">No grievances to display</div>
                            )}
                        </div>

                        {renderTable()}

                    </CardBody>
                </Card>

                {/* Single Rejection Modal */}
                <Modal
                    isOpen={customMsgModalOpen}
                    toggle={() => setCustomMsgModalOpen(false)}
                    centered
                >
                    <ModalHeader
                        className="bg-light"
                    >
                        Reject Grievance
                    </ModalHeader>
                    <ModalBody className="p-4">
                        <FormGroup>
                            <Label className="font-weight-bold mb-2">
                                Reason for rejection
                            </Label>
                            <Input
                                type="textarea"
                                rows="5"
                                className="form-control"
                                placeholder="Please provide a clear reason for the citizen..."
                                value={customReason}
                                onChange={(e) => setCustomReason(e.target.value)}
                                style={{ resize: "none" }}
                            />
                            <div className="d-flex justify-content-between mt-2">
                                <small className="text-muted">
                                    This message will be visible to the user.
                                </small>
                                <small
                                    className={
                                        customReason.length > 500
                                            ? "text-danger"
                                            : "text-muted"
                                    }
                                >
                                    {customReason.length}/500
                                </small>
                            </div>
                        </FormGroup>
                    </ModalBody>
                    <ModalFooter className="bg-light">
                        <Button
                            color="danger"
                            disabled={
                                !customReason.trim() ||
                                customReason.length > 500 ||
                                !canModerate
                            }
                            onClick={() =>
                                submitDecision(
                                    [targetGrievanceId],
                                    "reject",
                                    customReason.trim()
                                )
                            }
                        >
                            Confirm Rejection
                        </Button>
                    </ModalFooter>
                </Modal>

                {/* NEW: Bulk Rejection Modal */}
                <Modal
                    isOpen={bulkRejectModalOpen}
                    toggle={() => setBulkRejectModalOpen(false)}
                    centered
                >
                    <ModalHeader className="bg-light">
                        Bulk Reject Grievances
                    </ModalHeader>
                    <ModalBody className="p-4">
                        <div className="mb-3 text-muted small">
                            You are about to reject {selectedIds.size} selected grievances.
                        </div>
                        <FormGroup>
                            <Label className="font-weight-bold mb-2">
                                Select Reason for Rejection
                            </Label>
                            <Select
                                options={REJECTION_REASON_FILTER_OPTIONS}
                                value={bulkRejectReason}
                                onChange={setBulkRejectReason}
                                placeholder="Choose a reason..."
                            />
                        </FormGroup>

                        {bulkRejectReason?.value === "Other" && (
                            <FormGroup className="mt-3">
                                <Label className="font-weight-bold mb-2">
                                    Specific Reason
                                </Label>
                                <Input
                                    type="textarea"
                                    rows="4"
                                    className="form-control"
                                    placeholder="Type the specific reason here..."
                                    value={bulkCustomNote}
                                    onChange={(e) => setBulkCustomNote(e.target.value)}
                                    style={{ resize: "none" }}
                                />
                            </FormGroup>
                        )}
                    </ModalBody>
                    <ModalFooter className="bg-light">
                        <Button
                            color="secondary"
                            onClick={() => setBulkRejectModalOpen(false)}
                        >
                            Cancel
                        </Button>
                        <Button
                            color="danger"
                            disabled={
                                !bulkRejectReason ||
                                (bulkRejectReason.value === "Other" && !bulkCustomNote.trim()) ||
                                !canModerate
                            }
                            onClick={executeBulkReject}
                        >
                            Confirm Bulk Rejection
                        </Button>
                    </ModalFooter>
                </Modal>

                {/* Confirmation Modal (Accept / Resolve) */}
                <Modal
                    isOpen={confirmModalState.show}
                    centered
                    toggle={closeConfirmModal}
                >
                    <ModalHeader className="bg-light text-center">
                        {confirmModalState.title}
                    </ModalHeader>
                    <ModalBody className="p-4 text-center">
                        <p className="mb-0 text-muted" style={{ fontSize: "1.1rem" }}>
                            {confirmModalState.message}
                        </p>
                    </ModalBody>
                    <ModalFooter className="d-flex justify-content-center bg-light">
                        <Button
                            color={confirmModalState.btnColor}
                            onClick={executeConfirmation}
                        >
                            {confirmModalState.btnText}
                        </Button>
                        <Button
                            color="secondary"
                            onClick={closeConfirmModal}
                        >
                            Cancel
                        </Button>
                    </ModalFooter>
                </Modal>

                {/* Export Excel Modal */}
                <Modal isOpen={exportModalOpen} centered toggle={toggleExportModal}>
                    <ModalHeader className="bg-light text-center" >
                        Export Grievance Data
                    </ModalHeader>
                    <ModalBody>
                        <FormGroup>
                            <Label className="font-weight-bold mb-2">
                                Select Fields to Add in Excel File
                            </Label>
                            <div
                                className="border rounded p-2 overflow-auto"
                                style={{ maxHeight: "200px" }}
                            >
                                <div className="mb-2 d-flex align-items-center">
                                    <Input
                                        className="ml-0"
                                        type="checkbox"
                                        id="exportSelectAll"
                                        onChange={handleSelectAll}
                                        checked={
                                            exportFields.length === availableExportFields.length
                                        }
                                        style={{ position: 'relative', marginTop: 0 }}
                                    />
                                    <Label
                                        className="form-check-label ml-2 mb-0"
                                        htmlFor="exportSelectAll"
                                        style={{ cursor: "pointer" }}
                                    >
                                        Select All
                                    </Label>
                                </div>

                                {availableExportFields.map((field) => (
                                    <div className="d-flex align-items-center mb-1" key={field.key}>
                                        <Input
                                            className="ml-0"
                                            type="checkbox"
                                            id={field.key}
                                            onChange={() => handleFieldSelection(field.key)}
                                            checked={exportFields.includes(field.key)}
                                            style={{ position: 'relative', marginTop: 0 }}
                                        />
                                        <Label
                                            className="form-check-label ml-2 mb-0"
                                            htmlFor={field.key}
                                            style={{ cursor: "pointer" }}
                                        >
                                            {field.label}
                                        </Label>
                                    </div>
                                ))}
                            </div>
                        </FormGroup>
                        {exportError && (
                            <div className="text-danger text-center mt-3 small">
                                {exportError}
                            </div>
                        )}
                    </ModalBody>
                    <ModalFooter className="d-flex justify-content-center bg-light">
                        <Button color="primary" onClick={performExportExcel}>
                            Export
                        </Button>
                        <Button color="secondary" onClick={toggleExportModal}>
                            Cancel
                        </Button>
                    </ModalFooter>
                </Modal>
            </Container>
        </div>
    );
};

export default GrievanceDashboard;